import { movieService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationMoviesTMDB() {
	return useMutation({
		mutationFn: (getMoviesDto: { title: string; year: number }) => movieService.getMoviesTMDB(getMoviesDto)
	});
}
